<template>
  <div>
    <!-- edit trasnporter popup -->
    <vs-popup id="edit_transporter__modal" class="text-center" title="Edit Transporter" button-accept="false" button-cancel="false" :active.sync="isActive">
      <div class="vx-row pt-5 px-5">
        <div class="vx-col w-full md:w-1/2 px-8">
          <!-- transporter name -->
          <div class="vx-row mb-2">
            <label for="">Business Name <span class="text-danger">*</span></label>
            <vs-input icon="icon icon-home" v-model="form.business_name" icon-pack="feather" class="w-full" name="Business Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Business Name')">{{ errors.first('Business Name') }}</span>
          </div>

          <!-- mobile -->
          <div class="vx-row mb-2">
            <label for="">Mobile</label>
            <vs-input icon="icon icon-phone" v-model="form.phone" icon-pack="feather" class="w-full" name="Mobile" />
          </div>

          <!-- email -->
          <div class="vx-row mb-2">
            <label for="">Mail</label>
            <vs-input icon="icon icon-mail" v-model="form.email" icon-pack="feather" class="w-full" name="Email" />
          </div>

          <!-- licence number -->
          <div class="vx-row mb-2">
            <label for="">License Number <span class="text-danger">*</span></label>
            <vs-input icon="icon icon-file-text" v-model="form.license_number" icon-pack="feather" class="w-full" name="License Number" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('License Number')">{{ errors.first('License Number') }}</span>
          </div>

          <!-- address -->
          <div class="vx-row mb-2">
            <label for="">Address</label>
            <vs-input icon="icon icon-map-pin" v-model="form.address" icon-pack="feather" class="w-full" name="Address" />
          </div>

          <!-- vehicle no -->
          <div class="vx-row mb-2">
            <label for="">Vehicle Make</label>
            <vs-input icon="icon icon-edit" v-model="form.vehicle_make" icon-pack="feather" class="w-full" name="Vehicle Make" />
          </div>

          <!-- contact name -->
          <div class="vx-row mb-2">
            <label for="">Contact Name</label>
            <vs-input icon="icon icon-user" v-model="form.contact_name" icon-pack="feather" class="w-full" name="Contact Name" />
          </div>

          <!-- driver licence -->
          <div class="vx-row mb-2">
            <label for="">Driver's License #</label>
            <vs-input icon="icon icon-edit" icon-pack="feather" v-model="form.driver_license" class="w-full" name="Drivers License" />
          </div>
        </div>

        <div class="vx-col w-full md:w-1/2 px-8">
          <!-- zip code -->
          <div class="vx-row mb-2">
            <label for="">Zip Code</label>
            <vs-input icon="icon icon-map-pin" v-model="form.postcode" icon-pack="feather" class="w-full" name="Zip Code" />
          </div>

          <!-- role -->
          <div class="vx-row mb-2">
            <label for="">Role</label>
            <vs-input icon="icon icon-user" v-model="form.role" icon-pack="feather" class="w-full" name="Role" readonly />
            <span class="text-danger text-sm" v-show="errors.has('Role')">{{ errors.first('Role') }}</span>
          </div>

          <!-- city -->
          <div class="vx-row mb-3">
            <label for="">City</label>
            <select-2 class="w-full" autocomplete :value="form.cityId" @input="(item) => (form.cityId = item && item.value)" placeholder="Please Select City" name="City" action="getCityOptions" />
            <span class="text-danger text-sm" v-show="errors.has('City')">{{ errors.first('City') }}</span>
          </div>

          <!-- state -->
          <div class="vx-row mb-2">
            <label for="">State</label>
            <vs-input icon="icon icon-map-pin" v-model="form.state" icon-pack="feather" class="w-full" name="State" />
          </div>

          <!-- note -->
          <div class="vx-row mb-2">
            <label for="">Note</label>
            <vs-input icon="icon icon-file-text" v-model="form.note" icon-pack="feather" class="w-full" name="Note" />
          </div>

          <!-- vehicle model -->
          <div class="vx-row mb-2">
            <label for="">Vehicle Model</label>
            <vs-input icon="icon icon-edit" icon-pack="feather" v-model="form.vehicle_model" class="w-full" name="Vehicle Model" />
          </div>

          <!-- vehicle lic -->
          <div class="vx-row mb-2">
            <label for="">Vehicle Lic Plate #</label>
            <vs-input icon="icon icon-edit" icon-pack="feather" v-model="form.vehicle_lic_plate" class="w-full" name="Vehicle Lic Plate" />
          </div>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="float-right mr-5 vs-con-loading__container" type="relief" @click="save_changes" :disabled="!validateForm || loading">Save Changes</vs-button>
            <vs-button color="danger" type="relief" class="float-right" @click="isActive = false">Cancel</vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'EditTransporter',

  components: {
    Select2
  },

  props: {
    showModal: Boolean,
    transporterId: Number
  },

  data: () => ({
    loading: false,
    form: {
      business_name: '',
      phone: '',
      email: '',
      license_number: '',
      address: '',
      vehicle_make: '',
      contact_name: '',
      driver_license: '',
      postcode: '',
      role: 'Transporter',
      cityId: null,
      state: '',
      note: '',
      vehicle_model: '',
      vehicle_lic_plate: ''
    }
  }),

  async mounted() {
    const id = this.transporterId
    this.loading = true
    this.$store
      .dispatch('transporter/get', id)
      .then(({ data }) => {
        const { transporter } = data
        this.form.business_name = transporter.business_name
        this.form.role = transporter.role
        this.form.phone = transporter.phone
        this.form.email = transporter.email
        this.form.license_number = transporter.license_number
        this.form.address = transporter.address
        this.form.cityId = transporter.cityId
        this.form.state = transporter.state
        this.form.postcode = transporter.postcode
        this.form.note = transporter.note
        this.form.vehicle_make = transporter.vehicle_make
        this.form.contact_name = transporter.contact_name
        this.form.driver_license = transporter.driver_license
        this.form.vehicle_model = transporter.vehicle_model
        this.form.vehicle_lic_plate = transporter.vehicle_lic_plate
      })
      .catch((err) => {
        const { message } = err
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        this.isActive = false
      })
      .finally(() => {
        this.loading = false
      })
  },

  computed: {
    validateForm() {
      return !this.errors.any()
    },

    // close the poup
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  },

  methods: {
    async save_changes() {
      if (!(await this.$validator.validate())) {
        return false
      }

      this.loading = true
      this.$store
        .dispatch('transporter/update', { id: this.transporterId, data: this.form })
        .then(() => {
          this.$vs.notify({
            title: 'Success',
            text: 'Transporter updated successfully!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.$emit('updateList')
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
        .finally(() => {
          this.loading = false
          this.isActive = false
        })
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#edit_transporter__modal',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#edit_transporter__modal > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss">
#edit_transporter__modal {
  .vs-popup {
    width: calc(100% - 30%) !important;
  }
}
</style>
